import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-home-bridge-section',
  standalone: true,
  templateUrl: './home-bridge-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeBridgeSectionComponent {}

